import { setEventDetailExtract as setEventDetailExtractDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

export type Props = {
    type?: string;
}

export const setEventDetailExtract = ({
    type,
}: Props) => setEventDetailExtractDiagram({
    type,
});
